"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * pollination-server
 * Pollination Server OpenAPI Definition
 *
 * The version of the OpenAPI document: 1.1.1
 * Contact: info@pollination.cloud
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginsApi = exports.PluginsApiFactory = exports.PluginsApiFp = exports.PluginsApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const base_1 = require("../base");
/**
 * PluginsApi - axios parameter creator
 * @export
 */
const PluginsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a new plugin.
         * @summary Create a Plugin
         * @param {string} owner
         * @param {RepositoryCreate} repositoryCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlugin: (owner, repositoryCreate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling createPlugin.');
            }
            // verify required parameter 'repositoryCreate' is not null or undefined
            if (repositoryCreate === null || repositoryCreate === undefined) {
                throw new base_1.RequiredError('repositoryCreate', 'Required parameter repositoryCreate was null or undefined when calling createPlugin.');
            }
            const localVarPath = `/plugins/{owner}`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof repositoryCreate !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(repositoryCreate !== undefined ? repositoryCreate : {}) : (repositoryCreate || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a new plugin package version
         * @summary Create a new Plugin package
         * @param {string} owner
         * @param {string} name
         * @param {NewPluginPackage} newPluginPackage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPluginPackage: (owner, name, newPluginPackage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling createPluginPackage.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling createPluginPackage.');
            }
            // verify required parameter 'newPluginPackage' is not null or undefined
            if (newPluginPackage === null || newPluginPackage === undefined) {
                throw new base_1.RequiredError('newPluginPackage', 'Required parameter newPluginPackage was null or undefined when calling createPluginPackage.');
            }
            const localVarPath = `/plugins/{owner}/{name}/tags`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof newPluginPackage !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(newPluginPackage !== undefined ? newPluginPackage : {}) : (newPluginPackage || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete a plugin (must have `admin` permission)
         * @summary Delete a Plugin
         * @param {string} owner
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlugin: (owner, name, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling deletePlugin.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling deletePlugin.');
            }
            const localVarPath = `/plugins/{owner}/{name}`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete a plugin\'s access policy (must have `admin` permission)
         * @summary Remove a Repository permissions
         * @param {string} owner
         * @param {string} name
         * @param {RepositoryPolicySubject} repositoryPolicySubject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePluginOrgPermission: (owner, name, repositoryPolicySubject, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling deletePluginOrgPermission.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling deletePluginOrgPermission.');
            }
            // verify required parameter 'repositoryPolicySubject' is not null or undefined
            if (repositoryPolicySubject === null || repositoryPolicySubject === undefined) {
                throw new base_1.RequiredError('repositoryPolicySubject', 'Required parameter repositoryPolicySubject was null or undefined when calling deletePluginOrgPermission.');
            }
            const localVarPath = `/plugins/{owner}/{name}/permissions`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof repositoryPolicySubject !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(repositoryPolicySubject !== undefined ? repositoryPolicySubject : {}) : (repositoryPolicySubject || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a plugin by name
         * @summary Get a plugin
         * @param {string} owner
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlugin: (owner, name, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling getPlugin.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling getPlugin.');
            }
            const localVarPath = `/plugins/{owner}/{name}`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a plugin\'s access permissions (must have `write` permission)
         * @summary Get plugin access permissions
         * @param {string} owner
         * @param {string} name
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {Array<string>} [subjectType] The type of access policy subject
         * @param {Array<string>} [permission] An access policy permission string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPluginAccessPermissions: (owner, name, page, perPage, subjectType, permission, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling getPluginAccessPermissions.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling getPluginAccessPermissions.');
            }
            const localVarPath = `/plugins/{owner}/{name}/permissions`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per-page'] = perPage;
            }
            if (subjectType) {
                localVarQueryParameter['subject_type'] = subjectType;
            }
            if (permission) {
                localVarQueryParameter['permission'] = permission;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a plugin tag by name and tag
         * @summary Get a plugin tag
         * @param {string} owner
         * @param {string} name
         * @param {string} tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPluginByTag: (owner, name, tag, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling getPluginByTag.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling getPluginByTag.');
            }
            // verify required parameter 'tag' is not null or undefined
            if (tag === null || tag === undefined) {
                throw new base_1.RequiredError('tag', 'Required parameter tag was null or undefined when calling getPluginByTag.');
            }
            const localVarPath = `/plugins/{owner}/{name}/tags/{tag}`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"tag"}}`, encodeURIComponent(String(tag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a plugin by name
         * @summary Get a plugin tags
         * @param {string} owner
         * @param {string} name
         * @param {PackageSortKey} [sortBy] Key to sort the list by
         * @param {SortEnum} [sortOrder] The order to sort the list
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPluginTags: (owner, name, sortBy, sortOrder, page, perPage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling listPluginTags.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling listPluginTags.');
            }
            const localVarPath = `/plugins/{owner}/{name}/tags`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per-page'] = perPage;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List plugins
         * @param {Array<string>} [search] You know, for search
         * @param {Array<string>} [name] The account name
         * @param {Array<string>} [owner] Owner of the project
         * @param {boolean} [_public] Boolean check for public/private projects
         * @param {Array<string>} [keyword] A keyword to index the repository by
         * @param {Array<string>} [permission] Filter by permission on given resource
         * @param {RepositorySortKey} [sortBy] Key to sort the list by
         * @param {SortEnum} [sortOrder] The order to sort the list
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlugins: (search, name, owner, _public, keyword, permission, sortBy, sortOrder, page, perPage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/plugins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (search) {
                localVarQueryParameter['search'] = search;
            }
            if (name) {
                localVarQueryParameter['name'] = name;
            }
            if (owner) {
                localVarQueryParameter['owner'] = owner;
            }
            if (_public !== undefined) {
                localVarQueryParameter['public'] = _public;
            }
            if (keyword) {
                localVarQueryParameter['keyword'] = keyword;
            }
            if (permission) {
                localVarQueryParameter['permission'] = permission;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per-page'] = perPage;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update a plugin (must have `contribute` permission)
         * @summary Update a Plugin
         * @param {string} owner
         * @param {string} name
         * @param {RepositoryUpdate} repositoryUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlugin: (owner, name, repositoryUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling updatePlugin.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling updatePlugin.');
            }
            // verify required parameter 'repositoryUpdate' is not null or undefined
            if (repositoryUpdate === null || repositoryUpdate === undefined) {
                throw new base_1.RequiredError('repositoryUpdate', 'Required parameter repositoryUpdate was null or undefined when calling updatePlugin.');
            }
            const localVarPath = `/plugins/{owner}/{name}`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof repositoryUpdate !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(repositoryUpdate !== undefined ? repositoryUpdate : {}) : (repositoryUpdate || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Upsert a plugin\'s access policy (must have `admin` permission)
         * @summary Upsert a new permission to a plugin
         * @param {string} owner
         * @param {string} name
         * @param {RepositoryAccessPolicy} repositoryAccessPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPluginPermission: (owner, name, repositoryAccessPolicy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling upsertPluginPermission.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling upsertPluginPermission.');
            }
            // verify required parameter 'repositoryAccessPolicy' is not null or undefined
            if (repositoryAccessPolicy === null || repositoryAccessPolicy === undefined) {
                throw new base_1.RequiredError('repositoryAccessPolicy', 'Required parameter repositoryAccessPolicy was null or undefined when calling upsertPluginPermission.');
            }
            const localVarPath = `/plugins/{owner}/{name}/permissions`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof repositoryAccessPolicy !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(repositoryAccessPolicy !== undefined ? repositoryAccessPolicy : {}) : (repositoryAccessPolicy || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PluginsApiAxiosParamCreator = PluginsApiAxiosParamCreator;
/**
 * PluginsApi - functional programming interface
 * @export
 */
const PluginsApiFp = function (configuration) {
    return {
        /**
         * Create a new plugin.
         * @summary Create a Plugin
         * @param {string} owner
         * @param {RepositoryCreate} repositoryCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlugin(owner, repositoryCreate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.PluginsApiAxiosParamCreator)(configuration).createPlugin(owner, repositoryCreate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Create a new plugin package version
         * @summary Create a new Plugin package
         * @param {string} owner
         * @param {string} name
         * @param {NewPluginPackage} newPluginPackage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPluginPackage(owner, name, newPluginPackage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.PluginsApiAxiosParamCreator)(configuration).createPluginPackage(owner, name, newPluginPackage, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Delete a plugin (must have `admin` permission)
         * @summary Delete a Plugin
         * @param {string} owner
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlugin(owner, name, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.PluginsApiAxiosParamCreator)(configuration).deletePlugin(owner, name, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Delete a plugin\'s access policy (must have `admin` permission)
         * @summary Remove a Repository permissions
         * @param {string} owner
         * @param {string} name
         * @param {RepositoryPolicySubject} repositoryPolicySubject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePluginOrgPermission(owner, name, repositoryPolicySubject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.PluginsApiAxiosParamCreator)(configuration).deletePluginOrgPermission(owner, name, repositoryPolicySubject, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Retrieve a plugin by name
         * @summary Get a plugin
         * @param {string} owner
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlugin(owner, name, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.PluginsApiAxiosParamCreator)(configuration).getPlugin(owner, name, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Retrieve a plugin\'s access permissions (must have `write` permission)
         * @summary Get plugin access permissions
         * @param {string} owner
         * @param {string} name
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {Array<string>} [subjectType] The type of access policy subject
         * @param {Array<string>} [permission] An access policy permission string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPluginAccessPermissions(owner, name, page, perPage, subjectType, permission, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.PluginsApiAxiosParamCreator)(configuration).getPluginAccessPermissions(owner, name, page, perPage, subjectType, permission, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Retrieve a plugin tag by name and tag
         * @summary Get a plugin tag
         * @param {string} owner
         * @param {string} name
         * @param {string} tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPluginByTag(owner, name, tag, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.PluginsApiAxiosParamCreator)(configuration).getPluginByTag(owner, name, tag, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Retrieve a plugin by name
         * @summary Get a plugin tags
         * @param {string} owner
         * @param {string} name
         * @param {PackageSortKey} [sortBy] Key to sort the list by
         * @param {SortEnum} [sortOrder] The order to sort the list
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPluginTags(owner, name, sortBy, sortOrder, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.PluginsApiAxiosParamCreator)(configuration).listPluginTags(owner, name, sortBy, sortOrder, page, perPage, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary List plugins
         * @param {Array<string>} [search] You know, for search
         * @param {Array<string>} [name] The account name
         * @param {Array<string>} [owner] Owner of the project
         * @param {boolean} [_public] Boolean check for public/private projects
         * @param {Array<string>} [keyword] A keyword to index the repository by
         * @param {Array<string>} [permission] Filter by permission on given resource
         * @param {RepositorySortKey} [sortBy] Key to sort the list by
         * @param {SortEnum} [sortOrder] The order to sort the list
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlugins(search, name, owner, _public, keyword, permission, sortBy, sortOrder, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.PluginsApiAxiosParamCreator)(configuration).listPlugins(search, name, owner, _public, keyword, permission, sortBy, sortOrder, page, perPage, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Update a plugin (must have `contribute` permission)
         * @summary Update a Plugin
         * @param {string} owner
         * @param {string} name
         * @param {RepositoryUpdate} repositoryUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlugin(owner, name, repositoryUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.PluginsApiAxiosParamCreator)(configuration).updatePlugin(owner, name, repositoryUpdate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Upsert a plugin\'s access policy (must have `admin` permission)
         * @summary Upsert a new permission to a plugin
         * @param {string} owner
         * @param {string} name
         * @param {RepositoryAccessPolicy} repositoryAccessPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPluginPermission(owner, name, repositoryAccessPolicy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.PluginsApiAxiosParamCreator)(configuration).upsertPluginPermission(owner, name, repositoryAccessPolicy, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
    };
};
exports.PluginsApiFp = PluginsApiFp;
/**
 * PluginsApi - factory interface
 * @export
 */
const PluginsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * Create a new plugin.
         * @summary Create a Plugin
         * @param {string} owner
         * @param {RepositoryCreate} repositoryCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlugin(owner, repositoryCreate, options) {
            return (0, exports.PluginsApiFp)(configuration).createPlugin(owner, repositoryCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new plugin package version
         * @summary Create a new Plugin package
         * @param {string} owner
         * @param {string} name
         * @param {NewPluginPackage} newPluginPackage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPluginPackage(owner, name, newPluginPackage, options) {
            return (0, exports.PluginsApiFp)(configuration).createPluginPackage(owner, name, newPluginPackage, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a plugin (must have `admin` permission)
         * @summary Delete a Plugin
         * @param {string} owner
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlugin(owner, name, options) {
            return (0, exports.PluginsApiFp)(configuration).deletePlugin(owner, name, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a plugin\'s access policy (must have `admin` permission)
         * @summary Remove a Repository permissions
         * @param {string} owner
         * @param {string} name
         * @param {RepositoryPolicySubject} repositoryPolicySubject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePluginOrgPermission(owner, name, repositoryPolicySubject, options) {
            return (0, exports.PluginsApiFp)(configuration).deletePluginOrgPermission(owner, name, repositoryPolicySubject, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a plugin by name
         * @summary Get a plugin
         * @param {string} owner
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlugin(owner, name, options) {
            return (0, exports.PluginsApiFp)(configuration).getPlugin(owner, name, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a plugin\'s access permissions (must have `write` permission)
         * @summary Get plugin access permissions
         * @param {string} owner
         * @param {string} name
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {Array<string>} [subjectType] The type of access policy subject
         * @param {Array<string>} [permission] An access policy permission string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPluginAccessPermissions(owner, name, page, perPage, subjectType, permission, options) {
            return (0, exports.PluginsApiFp)(configuration).getPluginAccessPermissions(owner, name, page, perPage, subjectType, permission, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a plugin tag by name and tag
         * @summary Get a plugin tag
         * @param {string} owner
         * @param {string} name
         * @param {string} tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPluginByTag(owner, name, tag, options) {
            return (0, exports.PluginsApiFp)(configuration).getPluginByTag(owner, name, tag, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a plugin by name
         * @summary Get a plugin tags
         * @param {string} owner
         * @param {string} name
         * @param {PackageSortKey} [sortBy] Key to sort the list by
         * @param {SortEnum} [sortOrder] The order to sort the list
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPluginTags(owner, name, sortBy, sortOrder, page, perPage, options) {
            return (0, exports.PluginsApiFp)(configuration).listPluginTags(owner, name, sortBy, sortOrder, page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List plugins
         * @param {Array<string>} [search] You know, for search
         * @param {Array<string>} [name] The account name
         * @param {Array<string>} [owner] Owner of the project
         * @param {boolean} [_public] Boolean check for public/private projects
         * @param {Array<string>} [keyword] A keyword to index the repository by
         * @param {Array<string>} [permission] Filter by permission on given resource
         * @param {RepositorySortKey} [sortBy] Key to sort the list by
         * @param {SortEnum} [sortOrder] The order to sort the list
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlugins(search, name, owner, _public, keyword, permission, sortBy, sortOrder, page, perPage, options) {
            return (0, exports.PluginsApiFp)(configuration).listPlugins(search, name, owner, _public, keyword, permission, sortBy, sortOrder, page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a plugin (must have `contribute` permission)
         * @summary Update a Plugin
         * @param {string} owner
         * @param {string} name
         * @param {RepositoryUpdate} repositoryUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlugin(owner, name, repositoryUpdate, options) {
            return (0, exports.PluginsApiFp)(configuration).updatePlugin(owner, name, repositoryUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Upsert a plugin\'s access policy (must have `admin` permission)
         * @summary Upsert a new permission to a plugin
         * @param {string} owner
         * @param {string} name
         * @param {RepositoryAccessPolicy} repositoryAccessPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPluginPermission(owner, name, repositoryAccessPolicy, options) {
            return (0, exports.PluginsApiFp)(configuration).upsertPluginPermission(owner, name, repositoryAccessPolicy, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PluginsApiFactory = PluginsApiFactory;
/**
 * PluginsApi - object-oriented interface
 * @export
 * @class PluginsApi
 * @extends {BaseAPI}
 */
class PluginsApi extends base_1.BaseAPI {
    /**
     * Create a new plugin.
     * @summary Create a Plugin
     * @param {PluginsApiCreatePluginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    createPlugin(requestParameters, options) {
        return (0, exports.PluginsApiFp)(this.configuration).createPlugin(requestParameters.owner, requestParameters.repositoryCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new plugin package version
     * @summary Create a new Plugin package
     * @param {PluginsApiCreatePluginPackageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    createPluginPackage(requestParameters, options) {
        return (0, exports.PluginsApiFp)(this.configuration).createPluginPackage(requestParameters.owner, requestParameters.name, requestParameters.newPluginPackage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a plugin (must have `admin` permission)
     * @summary Delete a Plugin
     * @param {PluginsApiDeletePluginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    deletePlugin(requestParameters, options) {
        return (0, exports.PluginsApiFp)(this.configuration).deletePlugin(requestParameters.owner, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a plugin\'s access policy (must have `admin` permission)
     * @summary Remove a Repository permissions
     * @param {PluginsApiDeletePluginOrgPermissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    deletePluginOrgPermission(requestParameters, options) {
        return (0, exports.PluginsApiFp)(this.configuration).deletePluginOrgPermission(requestParameters.owner, requestParameters.name, requestParameters.repositoryPolicySubject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a plugin by name
     * @summary Get a plugin
     * @param {PluginsApiGetPluginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    getPlugin(requestParameters, options) {
        return (0, exports.PluginsApiFp)(this.configuration).getPlugin(requestParameters.owner, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a plugin\'s access permissions (must have `write` permission)
     * @summary Get plugin access permissions
     * @param {PluginsApiGetPluginAccessPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    getPluginAccessPermissions(requestParameters, options) {
        return (0, exports.PluginsApiFp)(this.configuration).getPluginAccessPermissions(requestParameters.owner, requestParameters.name, requestParameters.page, requestParameters.perPage, requestParameters.subjectType, requestParameters.permission, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a plugin tag by name and tag
     * @summary Get a plugin tag
     * @param {PluginsApiGetPluginByTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    getPluginByTag(requestParameters, options) {
        return (0, exports.PluginsApiFp)(this.configuration).getPluginByTag(requestParameters.owner, requestParameters.name, requestParameters.tag, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a plugin by name
     * @summary Get a plugin tags
     * @param {PluginsApiListPluginTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    listPluginTags(requestParameters, options) {
        return (0, exports.PluginsApiFp)(this.configuration).listPluginTags(requestParameters.owner, requestParameters.name, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List plugins
     * @param {PluginsApiListPluginsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    listPlugins(requestParameters = {}, options) {
        return (0, exports.PluginsApiFp)(this.configuration).listPlugins(requestParameters.search, requestParameters.name, requestParameters.owner, requestParameters._public, requestParameters.keyword, requestParameters.permission, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a plugin (must have `contribute` permission)
     * @summary Update a Plugin
     * @param {PluginsApiUpdatePluginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    updatePlugin(requestParameters, options) {
        return (0, exports.PluginsApiFp)(this.configuration).updatePlugin(requestParameters.owner, requestParameters.name, requestParameters.repositoryUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Upsert a plugin\'s access policy (must have `admin` permission)
     * @summary Upsert a new permission to a plugin
     * @param {PluginsApiUpsertPluginPermissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PluginsApi
     */
    upsertPluginPermission(requestParameters, options) {
        return (0, exports.PluginsApiFp)(this.configuration).upsertPluginPermission(requestParameters.owner, requestParameters.name, requestParameters.repositoryAccessPolicy, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PluginsApi = PluginsApi;
